// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-pills {
  margin-bottom: 24px;
  padding: 24px;
  background: var(--sebrae-white);
  border: 1px solid var(--sebrae-light-gray4);
  border-radius: 8px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1019607843);
}
.widget-pills__header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 4px;
  margin-bottom: 24px;
}
.widget-pills__header-icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1.5px solid #f7b500;
  position: relative;
}
.widget-pills__header-icon::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 2px;
  width: 6px;
  height: 6px;
  border: 1.5px solid #f7b500;
  border-bottom: 0;
  border-radius: 6px 6px 0 0;
  transform: translateX(-50%);
}
.widget-pills__header-icon::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 2px;
  width: 4px;
  height: 3px;
  background: #f7b500;
  border-radius: 1px;
  transform: translateX(-50%);
}
.widget-pills-title-section {
  font-family: Campuni, Figtree, "Open Sans";
  font-size: 16px;
  font-weight: 700;
  color: #24364b;
  margin: 0;
}
.widget-pills__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}
.widget-pills__card {
  min-width: 0;
}
.widget-pills__internal-link, .widget-pills__external-link {
  display: block;
  height: 100%;
  text-decoration: none;
  color: inherit;
}
.widget-pills__external-link--desktop {
  display: none;
}
.widget-pills__card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 122px;
  padding: 16px 16px 20px;
  background: var(--sebrae-white);
  border: 1px solid #e8edf3;
  border-radius: 10px;
  box-shadow: 0px 1px 4px 0px rgba(20, 46, 82, 0.2);
}
.widget-pills__card-content p {
  font-size: 12px !important;
  color: var(--sebrae-gray) !important;
}
.widget-pills__badge {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  min-height: 20px;
  padding: 4px;
  border-radius: 6px;
  background: var(--sebrae-light-pink);
  color: var(--sebrae-pink);
  font-size: 11px;
  font-weight: 700;
  margin-bottom: 10px;
}
.widget-pills__badge--coletanea {
  background: #dff7e8;
  color: #13985f;
}
.widget-pills h4 {
  color: #24364b;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 8px;
}
.widget-pills__footer {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 12px;
  margin-top: auto;
  padding-top: 4px;
}
.widget-pills__footer--coletanea {
  justify-content: flex-end;
  margin-top: 16px;
}
.widget-pills__meta, .widget-pills__action,
.widget-pills .link {
  display: inline-flex;
  align-items: center;
  gap: 13.34px;
  font-size: 12px;
  font-weight: 700;
}
.widget-pills__meta {
  color: #1f2937;
}
.widget-pills__action,
.widget-pills .link {
  color: var(--sebrae-blue);
}
.widget-pills__all {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}
.widget-pills__all .link {
  text-decoration: none;
}
@media screen and (min-width: 768px) {
  .widget-pills {
    padding: 24px;
  }
  .widget-pills-title-section {
    font-size: 23px;
  }
  .widget-pills__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .widget-pills__card-content {
    min-height: 154px;
  }
}
@media screen and (min-width: 1025px) {
  .widget-pills__external-link--mobile {
    display: none;
  }
  .widget-pills__external-link--desktop {
    display: block;
  }
}
@media screen and (min-width: 1200px) {
  .widget-pills {
    width: 100%;
    max-width: none;
  }
  .widget-pills__grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .widget-pills__card-content {
    min-height: 122px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/widget-pills/index.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,+BAAA;EACA,2CAAA;EACA,kBAAA;EACA,uDAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAEE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;AAAJ;AAEI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,0BAAA;EACA,2BAAA;AAAN;AAGI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;AADN;AAKE;EAEI,0CAAA;EACA,eAAA;EACA,gBAAA;EAEF,cAAA;EACA,SAAA;AALJ;AAQE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AANJ;AASE;EACE,YAAA;AAPJ;AAUE;EAEE,cAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;AATJ;AAaI;EACE,aAAA;AAXN;AAeE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,+BAAA;EACA,yBAAA;EACA,mBAAA;EACA,iDAAA;AAbJ;AAeI;EACE,0BAAA;EACA,oCAAA;AAbN;AAiBE;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,mBAAA;EACA,cAAA;AAfN;AAmBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAlBJ;AAoBI;EACE,yBAAA;EACA,gBAAA;AAlBN;AAsBE;;EAGE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AArBJ;AAwBE;EACE,cAAA;AAtBJ;AAyBE;;EAEE,yBAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAxBJ;AA0BI;EACE,qBAAA;AAxBN;AA4BE;EA3KF;IA4KI,aAAA;EAzBF;EA2BE;IACE,eAAA;EAzBJ;EA4BE;IACE,gDAAA;EA1BJ;EA6BE;IACE,iBAAA;EA3BJ;AACF;AA8BE;EAEI;IACE,aAAA;EA7BN;EAgCI;IACE,cAAA;EA9BN;AACF;AAkCE;EAvMF;IAwMI,WAAA;IACA,eAAA;EA/BF;EAiCE;IACE,gDAAA;EA/BJ;EAkCE;IACE,iBAAA;EAhCJ;AACF","sourcesContent":[".widget-pills {\n  margin-bottom: 24px;\n  padding: 24px;\n  background: var(--sebrae-white);\n  border: 1px solid var(--sebrae-light-gray4);\n  border-radius: 8px;\n  box-shadow: 0px 4px 4px 0px #0000001A;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-left: 4px;\n    margin-bottom: 24px;\n  }\n\n  &__header-icon {\n    flex-shrink: 0;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    border: 1.5px solid #f7b500;\n    position: relative;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 50%;\n      top: 2px;\n      width: 6px;\n      height: 6px;\n      border: 1.5px solid #f7b500;\n      border-bottom: 0;\n      border-radius: 6px 6px 0 0;\n      transform: translateX(-50%);\n    }\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      left: 50%;\n      bottom: 2px;\n      width: 4px;\n      height: 3px;\n      background: #f7b500;\n      border-radius: 1px;\n      transform: translateX(-50%);\n    }\n  }\n\n  &-title-section {\n    font: {\n      family: Campuni, Figtree, \"Open Sans\";\n      size: 16px;\n      weight: 700;\n    }\n    color: #24364b;\n    margin: 0;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  &__card {\n    min-width: 0;\n  }\n\n  &__internal-link,\n  &__external-link {\n    display: block;\n    height: 100%;\n    text-decoration: none;\n    color: inherit;\n  }\n\n  &__external-link {\n    &--desktop {\n      display: none;\n    }\n  }\n\n  &__card-content {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 122px;\n    padding: 16px 16px 20px;\n    background: var(--sebrae-white);\n    border: 1px solid #e8edf3;\n    border-radius: 10px;\n    box-shadow: 0px 1px 4px 0px #142E5233;\n\n    p {\n      font-size: 12px !important;\n      color: var(--sebrae-gray) !important;\n    }\n  }\n\n  &__badge {\n    display: inline-flex;\n    align-items: center;\n    align-self: flex-start;\n    min-height: 20px;\n    padding: 4px;\n    border-radius: 6px;\n    background: var(--sebrae-light-pink);\n    color: var(--sebrae-pink);\n    font-size: 11px;\n    font-weight: 700;\n    margin-bottom: 10px;\n\n    &--coletanea {\n      background: #dff7e8;\n      color: #13985f;\n    }\n  }\n\n  h4 {\n    color: #24364b;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.3;\n    margin-bottom: 8px;\n  }\n\n  &__footer {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    gap: 12px;\n    margin-top: auto;\n    padding-top: 4px;\n\n    &--coletanea {\n      justify-content: flex-end;\n      margin-top: 16px;\n    }\n  }\n\n  &__meta,\n  &__action,\n  .link {\n    display: inline-flex;\n    align-items: center;\n    gap: 13.34px;\n    font-size: 12px;\n    font-weight: 700;\n  }\n\n  &__meta {\n    color: #1f2937;\n  }\n\n  &__action,\n  .link {\n    color: var(--sebrae-blue);\n  }\n\n  &__all {\n    display: flex;\n    justify-content: center;\n    margin-top: 28px;\n\n    .link {\n      text-decoration: none;\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    padding: 24px;\n\n    &-title-section {\n      font-size: 23px;\n    }\n\n    &__grid {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    &__card-content {\n      min-height: 154px;\n    }\n  }\n\n  @media screen and (min-width: 1025px) {\n    &__external-link {\n      &--mobile {\n        display: none;\n      }\n\n      &--desktop {\n        display: block;\n      }\n    }\n  }\n\n  @media screen and (min-width: 1200px) {\n    width: 100%;\n    max-width: none;\n\n    &__grid {\n      grid-template-columns: repeat(4, minmax(0, 1fr));\n    }\n\n    &__card-content {\n      min-height: 122px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
